export class BillingRuleRateEntity {
    id;
    rateAmount;
    chargeBy;
    duration;
    period;
    rateIndex;
    billingRuleId;

    constructor(id, rateAmount, chargeBy, duration, period, rateIndex, billingRuleId) {
        this.id = id;
        this.rateAmount = rateAmount;
        this.chargeBy = chargeBy;
        this.duration = duration;
        this.period = period;
        this.rateIndex = rateIndex;
        this.billingRuleId = billingRuleId;
    }
}